// extracted by mini-css-extract-plugin
module.exports = {"feedbackCard":"feedback_card_feedbackCard__Bvf8b","form":"feedback_card_form__SqXYE","success":"feedback_card_success__LKQxK","successText":"feedback_card_successText__SFasK"};